module.exports = __webpack_public_path__ + "static/media/icons8-edit.68da3d69.svg";